<template>
    <div class="name-headline-description">
        <b-row>
            <b-col sm="5">
                <label for="name">
                    Card Name
                    <p><small>Give it a unique name to find it quicker</small></p>
                </label>
            </b-col>
            <b-col sm="7">
                <template v-if="cardNameError">
                    <small class="error">This card name already exists. Choose a different name.</small>
                </template>
                <b-form-input
                    id="name"
                    :class="{ error: cardNameError }"
                    v-model="value.cardName"
                    type="text"
                    placeholder="Card XXX"
                    required
                    autofocus
                    style="font-weight: bold"
                />
            </b-col>
        </b-row>

       <divider />

        <b-row>
            <b-col sm="5">
                <label for="title">
                    Headline
                    <p><small>Write an engaging headline</small></p>
                </label>
            </b-col>
            <b-col sm="7">
                <b-form-input
                    id="title"
                    v-model="value.cardTitle"
                    type="text"
                    placeholder="This is my title"
                    required
                /></b-col>
        </b-row>

        <b-row>
            <b-col sm="5">
                <label for="description">
                    Description
                    <p><small>Keep it short and simple</small></p>
                </label>
            </b-col>
            <b-col sm="7">
                <b-form-textarea
                    id="description"
                    :rows="2"
                    :max-rows="4"
                    v-model="value.cardDescription"
                    placeholder="This is my Description"
                    required
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import Divider from './divider'
  export default {
    name: 'name-headline-description',
    components: {
      Divider
    },
    props: {
      value: {
        type: Object,
        required: true
      },
      cardNameError: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
